import React from 'react';

import { Flex, Image, Text } from '@opendoor/bricks/core';

const PrivacyNotice: React.FC = () => {
  const privacyNotice =
    'For more information about how we collect and use your personal information to deliver our services, please see our';
  return (
    <Flex
      color="neutrals90"
      fontSize="s00"
      marginTop={[null, '10px', null, null]}
      justifyContent={['left', null, 'center']}
    >
      <Image
        src="https://imgdrop.imgix.net/lock.svg"
        mt={1}
        mr={[2, null, 1]}
        alt="Lock icon"
        width="10px"
        height="12px"
      />
      <Text textAlign={['left', null, 'center']}>
        {privacyNotice}&nbsp;
        <a href="https://www.opendoor.com/terms" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        .
      </Text>
    </Flex>
  );
};

export default PrivacyNotice;
